import React from "react";

/** Whether the icon should appear light (e.g. on dark bg). Used to pick img filter for theme. */
export const isLightIconColor = (color: string | undefined): boolean => {
  if (!color || typeof color !== "string") return false;
  const hex = color.trim().replace(/^#/, "");
  if (hex.length !== 3 && hex.length !== 6) return false;
  const r = hex.length === 3 ? parseInt(hex[0] + hex[0], 16) : parseInt(hex.slice(0, 2), 16);
  const g = hex.length === 3 ? parseInt(hex[1] + hex[1], 16) : parseInt(hex.slice(2, 4), 16);
  const b = hex.length === 3 ? parseInt(hex[2] + hex[2], 16) : parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6;
};

/** Twitter X icon (img) that respects socialIconColor / isHexDark via CSS filter */
export const TwitterIcon = ({
  iconStyle,
}: {
  iconStyle: React.CSSProperties;
}) => {
  const isLight = isLightIconColor(iconStyle.color as string);
  const baseFilter = isLight ? "brightness(0) invert(1)" : "brightness(0)";
  return (
    <img
      src="/assets/icons8-twitterx-30.png"
      alt="X (Twitter)"
      className="social-img"
      style={{
        width: "1em",
        height: "1em",
        filter: baseFilter,
        transition: "filter 0.2s",
        ...iconStyle,
      }}
      onMouseEnter={(e: any) => {
        e.target.style.filter = isLight ? "brightness(0) invert(1) brightness(0.6)" : "brightness(0.4)";
      }}
      onMouseLeave={(e: any) => {
        e.target.style.filter = baseFilter;
      }}
    />
  );
};
